import { AnchorHTMLAttributes, FC, HTMLAttributes } from 'react'

import { Link, LinkProps } from 'react-router-dom'
import styled, { css } from 'styled-components'

import { DropdownMenuDivider, DropdownMenuItem } from 'core/components/lib/DropdownMenu'
import { variables } from 'core/styles'

// The styling of this matches a <Select /> element, but using a form element
// to render this menu is semantically incorrect. Designs should be updated to
// differentiate between dropdown menus and form selects.

export const UserButton = styled.button<{ ref: any }>`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 200px;
  max-width: 214px;
  padding: 8px;
  font-size: 16px;
  color: ${variables.colorBlack70};
  cursor: pointer;
  background-color: ${variables.colorWhite};
  border: 1px solid ${variables.colorBlack30};
  border-radius: 4px;

  &[data-state='open'],
  &:hover {
    max-width: initial;
  }

  &[data-state='open'] {
    border-color: ${variables.colorBluePrimary};
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  &[data-state='closed'] {
    &:hover {
      border-color: ${variables.colorBlack40};
    }
  }
`

export const UserNameAndIcon = styled.span`
  display: flex;
  flex-shrink: 1;
  align-items: center;
  min-width: 0;

  > span {
    margin-left: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const UserDropdownWrapper = styled.div<{ $width: number }>`
  z-index: 10;
  box-sizing: border-box;
  width: ${(p) => p.$width}px;
  overflow: hidden;
  background: ${variables.colorWhite};
  border-right: 1px solid ${variables.colorBluePrimary};
  border-bottom: 1px solid ${variables.colorBluePrimary};
  border-left: 1px solid ${variables.colorBluePrimary};
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
`

export const UserDropdownDivider = styled(DropdownMenuDivider)`
  height: 1px;
  background-color: ${variables.colorBlack20};
`

const dropdownItemStyles = css`
  width: 100%;
  padding: 8px 12px;
  overflow: hidden;
  font-size: 16px;
  color: ${variables.colorBlack70};
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  background: none;
  border: none;

  &:hover {
    background-color: ${variables.colorBlack10};
  }
`

const StyledLink = styled(Link)`
  ${dropdownItemStyles}
  display: block;
`

const StyledLinkExternal = styled.a`
  ${dropdownItemStyles};
  display: block;
`

const StyledButton = styled.button`
  ${dropdownItemStyles}
`

export const UserDropdownLink: FC<LinkProps> = (props) => {
  return (
    <DropdownMenuItem>
      <StyledLink {...props} />
    </DropdownMenuItem>
  )
}

export const UserDropdownLinkExternal: FC<AnchorHTMLAttributes<HTMLAnchorElement>> = (props) => {
  return (
    <DropdownMenuItem>
      <StyledLinkExternal {...props} />
    </DropdownMenuItem>
  )
}

export const UserDropdownButton: FC<HTMLAttributes<HTMLButtonElement>> = (props) => {
  return (
    <DropdownMenuItem>
      <StyledButton {...props} />
    </DropdownMenuItem>
  )
}
